import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import Bubble from "../../assets/images/bubble.svg";

export const Container = styled(Grid)({
  backgroundImage: `url(${Bubble})`,
  padding: "18px",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  height: "141px",
  width: "240px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});
